import { memo } from 'react';
import { DropDownOption } from 'src/types';
import { Option } from './Option';

const _OptionsList = ({
  options,
  onClick,
  priorityElementId
}: {
  options: DropDownOption[];
  onClick: (option: DropDownOption) => void;
  priorityElementId?: string;
}) => {
  return (
    <>
      {options.map((option, index) => (
        <Option
          name={option.name}
          key={option.id}
          onClick={() => onClick(option)}
          style={{ order: priorityElementId === option.id ? 0 : index + 1 }}
        />
      ))}
    </>
  );
};

export const OptionsList = memo(_OptionsList);
